import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCapitalBalanceApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchCapitalBalance = createAsyncThunk(
  "capitalBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate || null,
      };
      const res = await getCapitalBalanceApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCapitalAccountsBySearch = createAsyncThunk(
  "capitalBalance/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        multiType: ["capital"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
